// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import InfoFlagStyled from "./InfoFlag.styled";

const Tab = props => {
    const { text } = props;
    return (
        <InfoFlagStyled ><span>{text}</span></InfoFlagStyled>
    );
};

Tab.propTypes = {
    text: PropTypes.string
};

export default Tab;
